import '../App.css';
import React, { useEffect, useState } from 'react'
import { Route, Switch, Redirect, useLocation } from 'react-router-dom'
import { makeStyles } from '@mui/styles';
import Header from './header/Header'
import Login from './login/Login'
import LoginReset from './login/LoginReset'
import { SnackbarProvider } from 'notistack';
import { API_BO } from '../conf'
import rout from '../functions/rout'
import routNotLogin from '../functions/rout_not_login'
import Notifier from '../components/Notifier'
import { ThemeProvider, StyledEngineProvider, createTheme } from '@mui/material/styles';
import RoutAdmin from './RoutAdmin'
import { useSelector, useDispatch } from 'react-redux';
import { fetchDispath } from '../functions/fetch'
import { getUserMe } from '../api/users'
import { editUser, loadPermissions } from '../reducers/users';
import { useCan } from 'src/hooks/useCan';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
  },

}));

function Root() {
  const token = useSelector(state => state?.user?.auth?.token)
  if (token) {
    return <RootAuth />
  }
  else {
    return <RootNotAuth />
  }
}

const STATIC_ROUTERS = rout()
function RootAuth() {
  const classes = useStyles()
  const dispatch = useDispatch()
  const accountId = useSelector(state => state?.user?.auth?.accountId)
  console.log('🎬 [RootAuth Render] Компонент отрендерился!');
  useEffect(() => {
    if (accountId) {
      return;
    }
    dispatch(fetchDispath({
      progress: true,
      request: getUserMe,
    })).then(res => {
      dispatch(loadPermissions({ permissions: res.get.permissions }))
      dispatch(editUser({
        accountId: res.get.accountId,
        accountName: res.get.accountName,
        g: res.get.g,
        id: res.get.id
      }))
    }).catch(err => console.log(err))
    return () => {
    }
  }, [dispatch, accountId])
  const can = useCan();
  return (
    <div className={classes.root}>
      <Notifier />
      <Header />
      <main className={classes.content}>
        <div className={classes.toolbar} />
        <ErrorBoundary>
          <Switch>
            <Route exact path={API_BO + '/login'} component={Login} />
            <Route exact path={API_BO + '/login-reset/:token'} component={LoginReset} />
            {STATIC_ROUTERS.map((obj, index) => {
              if (obj.check && !can(obj.check)) {
                return (
                  <Route 
                    exact 
                    path={obj.path} 
                    key={obj.path} // Используем путь в качестве стабильного key
                    render={() => { return <h1>403 Forbidden</h1> }}
                  />
                );
              }
              return <Route exact {...obj} key={obj.path} />
            })}
            <RoutAdmin />
            <Route render={() => { return <h1>Not found</h1> }} />
          </Switch>
        </ErrorBoundary>
      </main>
    </div>
  )
}
function RootNotAuth() {
  const routersNot = routNotLogin()
  return <div>
    <Notifier />
    <main>
      <Switch>
        {routersNot.map((obj, index) => <Route exact {...obj} key={index} />)}
        <Route render={() => <Redirect to={API_BO + "/login"} />} />
      </Switch>
    </main>
  </div>
}
const theme = createTheme({
  palette: {
    primary: {
      main: '#3f51b5',
    },
    secondary: {
      main: '#f50057',
    },
  },
});
function IntegrationNotification() {
  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
        >
          <Root />
        </SnackbarProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
export default IntegrationNotification;


function ErrorBoundary({ children }) {
  const [hasError, setHasError] = useState(false);
  const location = useLocation();
  useEffect(() => {
    if (hasError) {
      setHasError(false);
    }
  }, [location.key]);
  return (
    <ErrorBoundaryInner
      hasError={hasError}
      setHasError={setHasError}
    >
      {children}
    </ErrorBoundaryInner>
  );
}

class ErrorBoundaryInner extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error) {
    return { hasError: true };
  }

  componentDidUpdate(prevProps, _previousState) {
    if (!this.props.hasError && prevProps.hasError) {
      this.setState({ hasError: false });
    }
  }

  componentDidCatch(_error, _errorInfo) {
    this.props.setHasError(true);
  }

  render() {
    return this.state.hasError
      ? <h1>There was an error</h1>
      : this.props.children;
  }
}
